define('TescoMobile_DataLayer/js/model/step-navigator-mixin',['mage/utils/wrapper', 'jquery'], function (wrapper, $) {
  'use strict';

  return function (stepNavigator) {
    stepNavigator.navigateTo = wrapper.wrapSuper(stepNavigator.navigateTo, function (code) {
      var eventName = 'dl-checkout-step-' + code;
      if ($.data(document.body, 'dl-last-event') !== eventName) {
        var steps = this.steps(),
          currentStep = location.hash.replace('#', ''),
          currentStepNumber,
          codeStepNumber;
        _.each(steps, function (step, number) {
          if (step.code === code) {
            codeStepNumber = number;
            return;
          }
          if (step.code === currentStep) {
            currentStepNumber = number;
            return;
          }
        });
        if (codeStepNumber <= currentStepNumber) {
          $('body').trigger(eventName);
        }
        $.data(document.body, 'dl-last-event', eventName);
        $.data(document.body, 'dl-last-checkout-event', eventName);
      }
      return this._super(code);
    });
    stepNavigator.setHash = wrapper.wrapSuper(stepNavigator.setHash, function (hash) {
      if ($.data(document.body, 'dl-last-event') !== 'dl-checkout-step-' + hash) {
        $('body').trigger('dl-checkout-step-' + hash);
        $.data(document.body, 'dl-last-event', 'dl-checkout-step-' + hash);
        $.data(document.body, 'dl-last-checkout-event', 'dl-checkout-step-' + hash);
      }
      return this._super(hash);
    });
    stepNavigator.getActiveItemIndex = wrapper.wrapSuper(stepNavigator.getActiveItemIndex, function () {
      var steps = this.steps,
        eventName,
        checkoutInitCompleted = !!$.data(document.body, 'dl-checkout-init-completed');
      if (!checkoutInitCompleted) {
        steps().sort(this.sortItems).some(function (element) {
          if (element.isVisible()) {
            eventName = 'dl-checkout-step-' + element.code;
            if ($.data(document.body, 'dl-last-event') !== eventName) {
              $('body').trigger(eventName);
              $.data(document.body, 'dl-last-event', eventName);
              $.data(document.body, 'dl-last-checkout-event', eventName);
              $.data(document.body, 'dl-checkout-init-completed', true);
            }
            return true;
          }
          return false;
        });
      }
      return this._super();
    });
    return stepNavigator;
  };
});

